<nz-row nzJustify="space-between" nzAlign="middle" class="header-row">
  <nz-col>
    <h1 class="float-left">{{ title }}</h1>
  </nz-col>
  <div nz-row nzGutter="12">
    @if(crudEnabled) {
    <nz-col>
      <button class="float-right" nz-button (click)="openDrawer()" [disabled]="isAnyActionLoading"
        ><span nz-icon nzType="plus"></span
      ></button>
    </nz-col>
    } @if(syncEnabled) {
    <nz-col>
      <button
        class="float-right"
        nz-button
        (click)="syncEntities()"
        [nzLoading]="isSyncLoading"
        [disabled]="isAnyActionLoading"
        ><span nz-icon nzType="sync"></span
      ></button>
    </nz-col>
    }
  </div>
</nz-row>

<ldc-filter-pagi-table
  [tableState]="tableState"
  [columns]="columns"
  (queryParamsChange)="onQueryParamsChange($event)"
  (actionTriggered)="onActionTriggered($event)"
>
</ldc-filter-pagi-table>
<nz-drawer [nzVisible]="drawerVisible" [nzClosable]="false">
  <ng-container *nzDrawerContent>
    <ng-content select="[form]"></ng-content>
  </ng-container>
</nz-drawer>
